import {
  SESSION_LOGOUT,
  SESSION_FETCH_SUCCESS,
  SESSION_FETCH_INIT,
  SESSION_FETCH_FAIL,
  FEATUREFLAG_FETCH_SUCCESS,
  RESET_ERROR,
  SET_ERROR,
  SESSION_DATA_FETCH_SUCCESS,
  GET_JDX_SESSION_KEY,
  GET_JDX_SESSION_KEY_FAIL,
  GET_JDX_SESSION_KEY_SUCCESS,
  REFRESH_JDX_SESSION_KEY,
  ORGANIZATION_FETCH_SUCCESS
} from '../actions/session';

const initialState = {
  loggedIn: false,
  loading: false,
  error: false,
  user: {},
  organization: {},
  group: {},
  currency: {},
  replacementTokens: [],
  featureFlags: [],
  error502: false,
  lastErrorCode: null,
  salesforceID: 'Does not exist',
  defaultWeighting: 'one',
  groupMetaData: {},
  jdxSessionKey: null,
  jdxSessionTime: null,
  benchmarkYear: null,
  uniqueSalaryRange: false,
  onlyHasAccessToSiteLevelGroup: true
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SESSION_LOGOUT:
      return {
        ...state,
        loggedIn: false,
        loading: false,
        error: false,
        error502: false
      };
    case SESSION_FETCH_INIT:
      return {
        ...state,
        loading: true
      };
    case SESSION_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
        loggedIn: true,
        error: false
      };
    case SESSION_FETCH_FAIL:
      return {
        ...state,
        error502: true,
        loading: false
      };
    case FEATUREFLAG_FETCH_SUCCESS:
      return {
        ...state,
        featureFlags: action.data
      };
    case ORGANIZATION_FETCH_SUCCESS:
      return {
        ...state,
        organization: { ...action.data }
      };
    case RESET_ERROR:
      return {
        ...state,
        error: false
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.data === 502 || action.data === 504 ? state.error : true,
        lastErrorCode: action.data,
        error502: action.data === 502 || action.data === 504 ? true : state.error502,
        loading: false
      };
    case SESSION_DATA_FETCH_SUCCESS:
      return {
        ...state,
        ...action.data
      };
    case GET_JDX_SESSION_KEY:
      return {
        ...state
      };
    case GET_JDX_SESSION_KEY_FAIL:
      return {
        ...state,
        jdxSessionKey: null,
        jdxSessionTime: null
      };
    case GET_JDX_SESSION_KEY_SUCCESS:
      return {
        ...state,
        jdxSessionTime: Date.now(),
        jdxSessionKey: action.jdxSessionKey
      };
    case REFRESH_JDX_SESSION_KEY:
      return {
        ...state,
        jdxSessionTime: Date.now()
      };
    default:
      return state;
  }
}
